import { Component, signal } from '@angular/core';
import { TenantDetailDto } from '@artemis-software/wr-api';
import { currentTenantId, isInternalTenant } from '@/utils/admin-utils';
import { repairTasksVisible } from '@/utils/repair-task-visibility';

@Component({
  standalone: false,
  selector: 'wr-tenant-dashboard-page',
  templateUrl: './tenant-dashboard-page.component.html',
  styleUrls: ['./tenant-dashboard-page.component.scss']
})
export class TenantDashboardPageComponent {
  protected readonly TenantDetailDto = TenantDetailDto;

  isInternalTenant = isInternalTenant();
  currentTenantId = currentTenantId();
  readonly repairTasksVisible = repairTasksVisible();

  readonly selectedTenantId = signal<string | undefined>(undefined);

  get tenantId(): string {
    if (this.isInternalTenant()) {
      return this.selectedTenantId() ?? '';
    }
    return this.currentTenantId() || '';
  }
}
